<template>
  <div class="div-dropdown-component">
    <single-select-integer
      :value.sync="compValue"
      :value-property="'value'"
      :options="dropdownOptions"
      :readonly="readonly"
    />
    <span v-if="problemToList" class="text-danger">
      {{ errorMessage }}
    </span>
  </div>
</template>
  
<script>

export default {
  name: "UserDropdown",
  props: {
    userId: Number,
    usersOptions: Array,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    "single-select-integer": () => import("@/components_rms/base/SingleSelectInteger.vue"),
  },
  data() {
    return {
      errorMessage: null,
      dropdownOptions: [{ value: null, text: "Carregando usuários" }],
    };
  },
  created() {
    if (this.usersOptions && this.usersOptions != null) {
      this.dropdownOptions = this.usersOptions;
    } else {
      this.loadUsers();
    }
  },
  computed: {
    compValue: {
      get: function () {
        return this.userId;
      },
      set: function (newValue) {
        this.$emit("update:userId", newValue);
        this.$emit("change", newValue);
      },
    },
    problemToList() {
      return this.errorMessage && this.errorMessage != "";
    },
  },
  methods: {
    loadUsers() {
      this.$apiScheduler
        .get("/v1/user/company/dropdownOptions/")
        .then((response) => {
          this.dropdownOptions = response.data.map((item) => ({
            value: item.value,
            text: item.text,
          }));
        })
        .catch((error) => {
          this.dropdownOptions = [
            { value: null, text: "Erro ao carregar usuários" },
          ];
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.errorMessage = error.message;
          }
        });
    },
  },
  watch: {
    usersOptions(newValue) {
      this.dropdownOptions = newValue;
    },
  },
};
</script>